import React from 'react'

export default function PoliticaPrivacidade() {
  return (
    <section className="about-section" style={{ paddingTop: 32, paddingBottom: 48 }}>
      <div className="container" style={{ maxWidth: 960, display: 'grid', gap: 16 }}>
        <h1>Política de Privacidade – SIDES Mercado</h1>

        <div>
          <h2>1. Responsável pelo Tratamento de Dados</h2>
          <p>
            <strong>SIDES Mercado</strong><br />
            Startup de Inovação Social e Tecnológica<br />
            Endereço: Rua da Frente de Libertação, Nº 56, Sommerschield, Maputo – Moçambique<br />
            Email: <a href="mailto:info@govurb.co.mz">info@govurb.co.mz</a><br />
            WhatsApp: <a href="https://wa.me/258852620360" target="_blank" rel="noreferrer">+258 85 262 0360</a>
          </p>
        </div>

        <div>
          <h2>2. Fundamento Legal e Finalidade do Tratamento</h2>
          <p>
            Com base nos princípios do RGPD, tratamos os seus dados pessoais com base no consentimento,
            na execução de contrato (ex.: compras), no interesse legítimo (administrativo/estatístico)
            e no cumprimento de obrigações legais.
          </p>
          <ul className="check-list">
            <li>Processamento de pedidos e entregas</li>
            <li>Gestão de contas de utilizador</li>
            <li>Envio de comunicações de serviço (transacionais e promocionais)</li>
            <li>Atendimento ao cliente e suporte técnico</li>
            <li>Melhoria da experiência do utilizador</li>
          </ul>
        </div>

        <div>
          <h2>3. Tipos de Dados Coletados</h2>
          <ul className="check-list">
            <li>Nome completo</li>
            <li>Contacto telefónico e email</li>
            <li>Morada de entrega</li>
            <li>Dados de pagamento (não armazenamos números de cartão)</li>
            <li>Dados de navegação (cookies, IP, geolocalização aproximada)</li>
          </ul>
        </div>

        <div>
          <h2>4. Partilha de Dados</h2>
          <p>
            Não vendemos os seus dados. Poderão ser partilhados com parceiros logísticos, prestadores
            tecnológicos que operam a plataforma e autoridades legais quando exigido.
          </p>
        </div>

        <div>
          <h2>5. Armazenamento e Retenção</h2>
          <p>
            Conservamos os dados enquanto durar a relação contratual, pelo período necessário às obrigações
            legais/fiscais, ou até pedido de eliminação quando aplicável.
          </p>
        </div>

        <div>
          <h2>6. Direitos dos Utilizadores</h2>
          <p>
            Garantimos os direitos de acesso, retificação, apagamento, portabilidade, limitação/oposição e
            reclamação a uma autoridade de controlo. Para exercer, escreva para
            {' '}<a href="mailto:info@govurb.co.mz">info@govurb.co.mz</a>.
          </p>
        </div>

        <div>
          <h2>7. Cookies e Tecnologias Similares</h2>
          <p>
            Usamos cookies para análise, preferências e melhoria de usabilidade. Pode configurar ou desativar
            no seu navegador.
          </p>
        </div>

        <div>
          <h2>8. Segurança dos Dados</h2>
          <ul className="check-list">
            <li>Encriptação de dados sensíveis</li>
            <li>Acesso restrito à base de dados</li>
            <li>Monitorização de acessos e atividades</li>
          </ul>
        </div>

        <div>
          <h2>9. Atualizações à Política</h2>
          <p>
            Esta política pode ser atualizada. Recomendamos a leitura regular. Última atualização:
            {' '}<strong>27 de Outubro de 2025</strong>.
          </p>
        </div>
      </div>
    </section>
  )
}
